import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import * as ReactDOMClient from "react-dom/client";

import "./index.scss";
import Services from "./services/service-provider/Services";
import * as serviceWorker from "./serviceWorker";
import Head from "./components/head/Head";
import App from "./App";

const container = document.getElementById("root");
const root = ReactDOMClient.createRoot(container as any);

root.render(
  <Router>
    <Services>
      <Head />
      <App />
    </Services>
  </Router>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
